import React from "react";
import "../styles.css";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-main">
          <div className="footer-logo">
            <h3>ZEMAXI</h3>
            <p>Streamer & Tool Creator</p>
          </div>
          <div className="footer-links">
            <div className="footer-nav">
              <h4>Navigation</h4>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/about">About</a></li>
                <li><a href="/stream">Stream</a></li>
                <li><a href="/reviews">Reviews</a></li>
                <li><a href="/videos">Videos</a></li>
                <li><a href="/tools">Tools</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-social">
              <h4>Connect</h4>
              <ul>
                <li><a href="https://twitch.tv/zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-twitch"></i> Twitch</a></li>
                <li><a href="https://youtube.com/@zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-youtube"></i> YouTube</a></li>
                <li><a href="https://ko-fi.com/zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-ko-fi"></i> Ko-fi</a></li>
                <li><a href="https://instagram.com/zemaxiirl" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i> Instagram</a></li>
                <li><a href="https://x.com/zemaxiirl" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-x-twitter"></i> X</a></li>

              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 ZeMaxi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
